module.exports = __webpack_public_path__ + "assets/img/translate.e7bd3e31.png";